import {
  ArrowForwardIcon,
  ChevronLeftIcon,
  ChevronRightIcon
} from '@chakra-ui/icons';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getFromUrl, serverRequest } from '../../api/Api';
import { Clip, Icon, Smiley } from '../../components/Icons';
import ChatBubble from '../../components/Sessions/ChatBubble';
import ChatListItem from '../../components/Sessions/ChatListItem';
import Tabs, { BlockTabs } from '../../components/Tabs';
import { Caption, Headline } from '../../components/Texts/Texts';
import DashboardLayout from '../../layouts/dashboard/DashboardLayout';
import { colors } from '../../theme/colors';
// import { useSocket } from '../../hooks/useSocket';
import {
  Box,
  Button,
  Flex,
  Grid,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
  useDisclosure,
  useToast,
  Select,
  FormControl,
  FormLabel,
  Checkbox,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  VStack,
  HStack
} from '@chakra-ui/react';
import EmojiPicker from 'emoji-picker-react';
import { useSessionSocket } from 'hooks/useSessionSocket';
import Menu from '../../assets/svg/menu-blue.svg';
import { PrimaryButton, TextButton } from '../../components/Buttons/Buttons';
import ModalView from '../../components/Modal';
import PopoverMenu from '../../components/Popover';
import SafetyCasePanel, {
  isCaseSafetyFlagged
} from '../../components/Cases/SafetyCasePanel';
import { getCurrentRole } from '../../constants/roles';
import { fileSizes } from '../../utils/constants';
import { capitalize, fileToDataUri, getMediaType } from '../../utils/helper';

interface Message {
  _id?: string;
  createdAt?: string;
  timestamp?: string | number;
  user?: {
    _id: string;
    name: string;
    role: string;
  };
  message?: string;
  messages?: string[];
  type?: string;
  status?: string;
  // New structure fields
  text?: string;
  sender?: string;
  messageId?: string | null;
}

interface ChatSession {
  _id: string;
  status: string;
  createdAt: string;
  messages: Array<{
    text: string;
    timestamp: string;
    sender: string;
    messageId?: string | null;
  }>;
  user: {
    _id: string;
    name: string;
    role: string;
    phone?: string;
    whatsAppId?: string;
    whatsAppDisplayName?: string;
    ageGroup?: string;
    gender?: string;
    address?: string;
    employmentStatus?: string;
    questionProgress?: number;
    isEnabled?: boolean;
    isBlocked?: boolean;
    rooms?: any[];
    password?: string;
    createdAt?: string;
    email?: string;
    deviceToken?: string;
    country?: string;
    dob?: string;
    symptoms?: {
      depression: number;
      stress: number;
      anxiety: number;
      others: number;
      _id?: string;
    };
  };
  case: string;
  __v: number;
}

const Sessions = () => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isCaseModalOpen,
    onOpen: onCaseModalOpen,
    onClose: onCaseModalClose
  } = useDisclosure();
  const toast = useToast();
  const messagesEndRef = useRef<null | HTMLDivElement>(null);
  const location: any = useLocation();
  const data = location.state?.case;
  const activeTab = location.state?.activeTab;
  const [caption, setCaption] = useState('');
  const [media, setMedia] = useState<string | null>(null);
  const [sessions, setSessions] = useState([]);
  const [statusFilter, setStatusFilter] = useState('active');
  const [sessionFilter, setSessionFilter] = useState(
    activeTab || 'all sessions'
  );
  const [closeCaseLoading, setCloseCaseLoading] = useState(false);
  const [reason, setReason] = useState('');
  const [file, setFile] = useState<File | null>(null);
  
  // Close case form fields
  const [backstory, setBackstory] = useState('');
  const [hasClientFilledForm, setHasClientFilledForm] = useState(false);
  const [counsellingTeam, setCounsellingTeam] = useState('UNASIGNED');
  const [helpProvided, setHelpProvided] = useState('');
  const [overallFeedback, setOverallFeedback] = useState('');
  const [sessionNumber, setSessionNumber] = useState(1);
  const [hasResidueEmotion, setHasResidueEmotion] = useState(false);
  const [averageTimeOnSession, setAverageTimeOnSession] = useState('');
  const [threatSummary, setThreatSummary] = useState('');
  const [actionsTaken, setActionsTaken] = useState('');
  const [supervisorNotified, setSupervisorNotified] = useState(true);
  const [clientSafetyPlan, setClientSafetyPlan] = useState('');
  const [emergencyServicesContacted, setEmergencyServicesContacted] =
    useState(false);
  const [session, setSession] = useState<any>(data || null);
  const prevSessionRef = useRef<any>(null);
  const currentRole = getCurrentRole();
  const caseItem = session?.case;
  const caseId = caseItem?._id || session?.case;
  
  // Update session only when data actually changes
  useEffect(() => {
    if (data && JSON.stringify(data) !== JSON.stringify(prevSessionRef.current)) {
      console.log('📱 Session data changed, updating session state', { 
        oldSessionId: prevSessionRef.current?._id, 
        newSessionId: data?._id,
        timestamp: new Date().toISOString() 
      });
      prevSessionRef.current = data;
      setSession(data);
    }
  }, [data]);
  const [chatData, setChatData] = useState<Message[]>([]);
  const [message, setMessage] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchResults, setSearchResults] = useState<any>([]);
  const [showEmoji, toggleEmoji] = useState(false);

  // const { socket } = useSocket('sessions');
  const { receive, connected, clientSocketRef, send } =
    useSessionSocket('sessions');
  // socket.clientRegister('patient_message', (data) => {
  //   addMessageToArray(data);
  // });

  const attachRef = useRef<HTMLInputElement | null>(null);

  const addMessageToArray = (message: any) => {
    const newMessages = [...chatData, message];
    setChatData(newMessages as any);
    scrollToBottom();
  };
  useEffect(() => {
    const result = sessions.filter((session: any) => {
      if (sessionFilter === 'all sessions')
        return session?.user?.name
          .toLowerCase()
          .includes(searchKeyword.toLowerCase());
      if (sessionFilter === 'my sessions')
        return session?.case?.user?.name
          .toLowerCase()
          .includes(searchKeyword.toLowerCase());
    });
    setSearchResults(result);
  }, [searchKeyword]);

  const getSessions = async () => {
    let endpoint = `cases/sessions`;
    if (sessionFilter === 'all sessions') {
      endpoint = `cases/sessions/all`;
    }
    try {
      const sessions = await getFromUrl(
        `${endpoint}?stage=${statusFilter.toUpperCase()}`
      );
      if (sessions.status === 401) navigate('/authentication/signin');
      if (sessions !== undefined) {
        setSessions(sessions);
        setSearchResults(sessions);
      }
    } catch (e: any) {
      console.error(e.message);
    }
  };

  const closeCase = async () => {
    setCloseCaseLoading(true);
    try {
      if (
        isCaseSafetyFlagged(caseItem) &&
        !caseItem?.safetyReview?.completedAt
      ) {
        if (!threatSummary.trim() || !actionsTaken.trim()) {
          toast({
            position: 'top',
            title: 'Error',
            description: 'Safety review form is required before closing',
            status: 'error',
            duration: 3000,
            isClosable: true
          });
          setCloseCaseLoading(false);
          return;
        }

        const reviewResponse = await serverRequest({
          endpoint: `cases/${caseId}/safety-review`,
          method: 'PUT',
          body: {
            threatSummary,
            actionsTaken,
            supervisorNotified,
            clientSafetyPlan: clientSafetyPlan || undefined,
            emergencyServicesContacted
          }
        });

        if (reviewResponse?.status === 401) {
          navigate('/authentication/signin');
          setCloseCaseLoading(false);
          return;
        }
      }

      const response = await serverRequest({
        endpoint: `cases/close`,
        method: 'PUT',
        body: {
          caseId,
          reason,
          backstory,
          hasClientFilledForm,
          counsellingTeam,
          helpProvided,
          overallFeedback,
          sessionNumber,
          hasResidueEmotion,
          averageTimeOnSession
        }
      });
      getSessions().catch(() => {
        return;
      });
      setCloseCaseLoading(false);
      if (response.status === 401) navigate('/authentication/signin');
      if (response.status === 400) {
        toast({
          position: 'top',
          title: 'Error',
          description:
            response?.data?.message ||
            'Error closing case. Super Admin approval may be required.',
          status: 'error',
          duration: 5000,
          isClosable: true
        });
      } else {
        onCaseModalClose();
        toast({
          position: 'top',
          title: 'Success',
          description: 'Case closed successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
          onCloseComplete: () => window.location.reload()
        });
      }
    } catch (e: any) {
      setCloseCaseLoading(false);
      toast({
        position: 'top',
        title: 'Error',
        description:
          e?.message ||
          'Failed to close case. Super Admin approval may be required.',
        status: 'error',
        duration: 5000,
        isClosable: true
      });
    }
  };

  const refreshCaseDetail = async () => {
    if (!caseId) {
      return;
    }
    try {
      const fetched = await getFromUrl(`cases/${caseId}`);
      if (fetched) {
        setSession((prev: any) => ({ ...prev, case: fetched }));
      }
    } catch {
      return;
    }
  };

  useEffect(() => {
    setSearchResults([]);
    setSearchKeyword('');
    getSessions().catch((err) => console.error(err));
  }, [statusFilter, sessionFilter]);

  // useEffect(() => {
  //   console.log(connected);
  //   if (connected) {
  //     console.log(session?.user);
  //   }
  // }, [connected]);

  useEffect(() => {
    if (connected) {
      const handleMessage = (dt: any) => {
        console.log('📨 New incoming message', dt);
        // Use current session values instead of closure values
        const currentSession = session;
        const currentCaseId = currentSession?.case?._id || currentSession?.case;
        if (dt?.caseId === currentCaseId?.toString()) {
          console.log('🔄 Triggering getChatHistory from WebSocket message');
          getChatHistory(true).catch(() => {
            return;
          });
        }
      };

      receive('patient_message', handleMessage);

      return () => {
        // Clean up the listener to prevent duplicate events
        clientSocketRef.current?.off('patient_message', handleMessage);
      };
    }
  }, [connected, receive]); // Removed session dependencies to prevent re-runs

  const handleStatusFilter = (filter: string) => {
    setSession(null);
    setStatusFilter(filter);
  };

  const handleSessionFilter = (filter: string) => {
    setSession(null);
    setSessionFilter(filter);
  };

  const cacheChatHistory = (chatHistory: unknown) => {
    const sessions = localStorage.getItem('sessions');
    let sessionsArr;
    if (!sessions) sessionsArr = {};
    if (sessions) sessionsArr = JSON.parse(sessions);
    sessionsArr[session?.user?.phone] = chatHistory;
    localStorage.setItem('sessions', JSON.stringify(sessionsArr));
  };


  const getChatHistory = async (forceRefresh = false) => {
    const caseId = session?.case?._id || session?.case || session?._id;
    console.log('🔄 getChatHistory called', { forceRefresh, caseId, timestamp: new Date().toISOString() });
    try {
      if (!caseId) return;

      // Clear cache if force refresh is requested
      if (forceRefresh) {
        localStorage.removeItem(`chat_${caseId}`);
      }

      // Check if we have cached data and it's recent (within last 30 seconds)
      const cacheKey = `chat_${caseId}`;
      const cachedData = localStorage.getItem(cacheKey);
      const cacheTimestamp = localStorage.getItem(`${cacheKey}_timestamp`);
      
      if (!forceRefresh && cachedData && cacheTimestamp) {
        const cacheAge = Date.now() - parseInt(cacheTimestamp);
        if (cacheAge < 30000) { // 30 seconds
          const parsedCache = JSON.parse(cachedData);
          setChatData(parsedCache);
          scrollToBottom();
          return;
        }
      }

      // Fetch chat history - try without pagination first
      const endpoint = `cases/sessions/chat/${caseId}`;
      console.log(`📄 Fetching chat history from ${endpoint}`);
      const res = await getFromUrl(endpoint);
      
      let allMessages: Message[] = [];
      
      if (typeof res === 'object' && Array.isArray(res)) {
        console.log(`📄 Received ${res.length} session objects in response`);
        
        // Handle new chat history format with session objects
        const chatSessions = res as ChatSession[];
        const flattenedMessages: Message[] = [];
        
        chatSessions.forEach((session) => {
          session.messages.forEach((msg) => {
            flattenedMessages.push({
              _id: msg.messageId || `msg-${Date.now()}-${Math.random()}`,
              text: msg.text,
              timestamp: msg.timestamp,
              createdAt: msg.timestamp,
              sender: msg.sender,
              messageId: msg.messageId || undefined,
              user: {
                _id: session.user._id,
                name: session.user.name,
                role: session.user.role
              }
            });
          });
        });
        
        allMessages = flattenedMessages;
      } else {
        console.log(`📄 Received non-array response, treating as empty`);
        allMessages = [];
      }

      if (allMessages.length > 0) {
        // Sort messages by timestamp to ensure correct order
        const sortedMessages = allMessages.sort((a, b) => {
          const timeA = new Date(a.createdAt || a.timestamp || 0).getTime();
          const timeB = new Date(b.createdAt || b.timestamp || 0).getTime();
          return timeA - timeB;
        });

        console.log('📝 Setting chatData with', sortedMessages.length, 'messages');
        setChatData(sortedMessages);
        cacheChatHistory(sortedMessages);
        
        // Update cache timestamp
        localStorage.setItem(`${cacheKey}_timestamp`, Date.now().toString());
      }
      
      scrollToBottom();
    } catch (e) {
      console.error('Error fetching chat history:', e);
      return;
    }
  };

  const addMessage = async (message: string) => {
    setMessage('');
    console.log(session);
    
    // Get current user from localStorage to determine role
    const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    
    const optimisticMessage = {
      _id: `temp-${Date.now()}+${session?.user?._id}+${message}`,
      messages: [message.trim()],
      text: message.trim(), // Add text field for new structure compatibility
      user: {
        ...(session?.supervisor ? session.supervisor : session?.counsellor),
        role: currentUser.role || 'SUPER_ADMIN' // Ensure role is set for positioning
      },
      isPending: false,
      createdAt: new Date().toISOString()
    };
    setChatData((prev) => [...prev, optimisticMessage]);

    // const pendingMessage = {
    //   id: Math.random() * 1000,
    //   direction: 'outbound',
    //   to: session?.user?.phone,
    //   type: 'text',
    //   text: {
    //     body: message
    //   }
    // };
    // addMessageToArray(pendingMessage);
    // const body = {
    //   whatsAppId:
    //     session?.user?.role === 'SUPER_ADMIN'
    //       ? session?.case?.user?.phone
    //       : session?.user?.phone,
    //   type: 'text',
    //   message
    // };
    // await serverRequest({
    //   endpoint: 'webhook/messages',
    //   body,
    //   method: 'post'
    // });

    send('session', {
      counsellorId: session?.supervisor
        ? session.supervisor
        : session?.counsellor,
      caseId: session?.case?._id ?? session?._id,
      message: message
    });
    scrollToBottom();
    // getChatHistory();
  };

  const addAttachment = (e: any) => {
    const attachment = e?.target?.files[0];
    if (attachment) {
      setFile(attachment);

      fileToDataUri(attachment).then(async (dataUri: any) => {
        const blob = new Blob([dataUri]);
        const objectUrl = window.URL.createObjectURL(blob);
        setMedia(objectUrl);
      });
      onOpen();
    }
    e.target.value = '';
  };

  const sendAttachment = () => {
    onClose();
    if (file && media) {
      const mediaType = getMediaType(file.type);
      const pendingMessage = {
        id: Math.round(Math.random() * 100000),
        status: 'pending',
        direction: 'outbound',
        to: session?.user.phone,
        type: mediaType,
        [mediaType as string]: {
          media: file,
          caption: caption || file.name
        }
      };
      addMessageToArray(pendingMessage);
      const token = localStorage.getItem('access_token');
      const body = new FormData();
      body.append('file', file);
      fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/webhook/media`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body
      })
        .then((res) => res.json())
        .then((data) => {
          const mediaId = data.mediaId;
          const body = {
            whatsAppId:
              session?.user?.role === 'SUPER_ADMIN'
                ? session?.case?.user?.phone
                : session?.user?.phone,
            type: mediaType,
            mediaId,
            caption
          };
          serverRequest({
            endpoint: 'webhook/messages',
            body,
            method: 'POST'
          }).catch(() => {
            return;
          });
        });
      setCaption('');
      setFile(null);
    }
  };

  useEffect(() => {
    console.log('📱 Session useEffect triggered', { 
      sessionName: session?.user?.name, 
      caseId: session?.case?._id || session?.case, 
      sessionId: session?._id,
      timestamp: new Date().toISOString() 
    });
    
    // Only proceed if session has actually changed
    if (session && JSON.stringify(session) !== JSON.stringify(prevSessionRef.current)) {
      console.log('🧹 Clearing chatData for new session');
      prevSessionRef.current = session;
      setChatData([]);
      const cachedSessions = localStorage.getItem('sessions');
      if (cachedSessions) {
        const sessionsArr = JSON.parse(cachedSessions);
        if (sessionsArr[session.user.phone] !== undefined)
          setChatData(sessionsArr[session.user.phone]);
      }
      getChatHistory(true).catch((err) => console.error(err));
      scrollToBottom();
    }
  }, [session]);

  // Populate form fields when modal opens
  useEffect(() => {
    if (isCaseModalOpen && session) {
      // Set default values from session data
      setSessionNumber(session?.sessionNumber || 1);
      setCounsellingTeam(session?.counsellingTeam || 'UNASIGNED');
      setAverageTimeOnSession(session?.averageTimeOnSession || '');
      
      // Clear other fields for fresh input
      setReason('');
      setBackstory('');
      setHelpProvided('');
      setOverallFeedback('');
      setHasClientFilledForm(false);
      setHasResidueEmotion(false);
      setThreatSummary('');
      setActionsTaken('');
      setClientSafetyPlan('');
      setSupervisorNotified(true);
      setEmergencyServicesContacted(false);
    }
  }, [isCaseModalOpen, session]);

  // Note: Removed automatic polling - chat history should be updated via WebSocket events
  // and manual refresh when needed. The previous setInterval was causing unnecessary API calls.

  const scrollToBottom = () => {
    return messagesEndRef.current?.scrollIntoView();
  };

  const handleKeyPress = (key: string) => {
    if (key === 'Enter' && message.trim().length) {
      addMessage(message).catch((err) => console.error(err));
    }
  };

  const canSendMedia = (file: File) => {
    if (file) {
      const mediaType = getMediaType(file?.type);
      if (mediaType === 'document' && file.size > 5000000) return true;
      if (
        (mediaType === 'audio' || mediaType === 'video') &&
        file.size > 16000000
      )
        return true;
      if (mediaType === 'image' && file.size > 5000000) return true;
      if (mediaType === 'sticker' && file.size > 100000) return true;
    }
  };
  return (
    <DashboardLayout pageTitle='Sessions'>
      <Grid gridTemplateColumns='1fr  2.4fr' mt='-54px' pb='108px'>
        <Flex
          flexDirection='column'
          borderRight={`1px solid ${colors.shade}`}
          h='calc(100vh - 84px)'
        >
          <Box
            borderBottomWidth='1px'
            borderBottomColor='shade'
            pt='24px'
            mb='32px'
            ml='30px'
          >
            <Tabs
              tabs={['all sessions', 'my sessions']}
              activeTab={sessionFilter}
              tabAction={handleSessionFilter}
            />
          </Box>
          <Box px='30px'>
            <Input
              placeholder='Search sessions...'
              fontSize='14px'
              minW='244px'
              h='48px'
              borderRadius='12px'
              borderWidth='1px'
              borderColor='gray.200'
              bg='white'
              mb='24px'
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              _focus={{
                borderColor: colors.deep_blue,
                boxShadow: `0 0 0 1px ${colors.deep_blue}`,
                outline: 'none'
              }}
              _placeholder={{
                color: 'gray.500'
              }}
              boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)'
            />
          </Box>
          <Box px='30px' mb='16px'>
            <BlockTabs
              tabs={['active', 'closed']}
              activeTab={statusFilter}
              tabAction={handleStatusFilter}
              centered
            />
          </Box>
          <Box 
            flex={1} 
            overflowY='scroll' 
            mt='20px' 
            pr='8px'
            pl='8px'
            maxH='calc(100vh - 200px)'
          >
            {sessionFilter === 'all sessions' && searchResults.length
              ? searchResults.map((item: any) => {
                  const { _id, user, lastMessage } = item;
                  console.log('ITEM', item?.supervisor);
                  return (
                    <ChatListItem
                      key={_id}
                      name={(user as any)?.name}
                      time={(lastMessage as any)?.lastClientMessageTime}
                      message={(lastMessage as any)?.message}
                      count={0}
                      onClick={() => setSession(item)}
                      active={_id === session?._id}
                    />
                  );
                })
              : null}
            {sessionFilter === 'my sessions' && searchResults.length
              ? searchResults.map((item: any) => {
                  console.log('MY SESSION ITEM', item);
                  const { _id, case: caseItem } = item;
                  return (
                    <ChatListItem
                      key={_id}
                      name={(caseItem?.user as any)?.name}
                      time={
                        (caseItem?.user?.lastMessage as any)
                          ?.lastClientMessageTime ||
                        (caseItem?.lastMessage as any)?.lastClientMessageTime
                      }
                      message={
                        (caseItem?.user?.lastMessage as any)?.message ||
                        (caseItem?.lastMessage as any)?.message
                      }
                      count={0}
                      onClick={() => setSession(item)}
                      active={_id === session?._id}
                    />
                  );
                })
              : null}
            {!searchResults.length && searchKeyword.length ? (
              <Text color={colors.deep_blue} mt='10px'>
                {`No session found for ${searchKeyword}`}
              </Text>
            ) : null}
          </Box>
        </Flex>
        <Flex flexDirection='column' h='calc(100vh - 84px)'>
          {session && (
            <>
              <Flex
                bg='white'
                h='80px'
                px='44px'
                alignItems='center'
                justifyContent='space-between'
              >
                <Flex bg='white' h='80px' px='44px' alignItems='center'>
                  <Box>
                    <Caption color='gray'>Client</Caption>
                    <Headline size='19px' color='deep_blue' fontWeight={500}>
                      {session?.user?.name ?? session?.case?.user?.name}
                    </Headline>
                  </Box>
                  <Box ml='20px'>
                    <PrimaryButton
                      label='Refresh'
                      onClick={() => getChatHistory(true)}
                      height='32px'
                      fontSize='12px'
                      px='16px'
                    />
                  </Box>
                  {sessionFilter === 'all sessions' && (
                    <>
                      <ChevronLeftIcon color='deep_blue' ml='30px' mt='20px' />
                      <ChevronRightIcon color='deep_blue' mr='30px' mt='20px' />
                      <Box mr='auto'>
                        <Caption color='gray'>Counsellor</Caption>
                        <Headline
                          size='19px'
                          color='deep_blue'
                          fontWeight={500}
                        >
                          {session?.supervisor
                            ? session?.supervisor?.name
                            : session?.counsellor?.name}
                        </Headline>
                      </Box>
                    </>
                  )}
                </Flex>
                <PopoverMenu
                  trigger={
                    <Image
                      src={Menu}
                      alt={``}
                      width={4}
                      height={16}
                      boxSize={4}
                      cursor='pointer'
                    />
                  }
                  top='85px'
                  left='10'
                  w='234px'
                  placement='right'
                >
                  {(onClose: any) => (
                    <Box fontSize='19px' fontWeight={500} color='gray'>
                      {caseItem?.stage !== 'CLOSED' &&
                        !caseItem?.autoClosedDueToSafety && (
                          <Flex
                            onClick={() => {
                              onClose();
                              onCaseModalOpen();
                            }}
                            fontSize='19px'
                            py='14px'
                            justifyContent='center'
                            cursor='pointer'
                            color={colors.error}
                          >
                            Close Case
                          </Flex>
                        )}
                    </Box>
                  )}
                </PopoverMenu>
              </Flex>
              {caseId && isCaseSafetyFlagged(caseItem) && (
                <Box px='16px'>
                  <SafetyCasePanel
                    caseItem={caseItem}
                    caseId={caseId}
                    currentRole={currentRole}
                    onUpdated={refreshCaseDetail}
                  />
                </Box>
              )}
              <Box 
                flex={1} 
                overflowY='scroll' 
                py='24px' 
                px='48px'
                bg='gray.50'
                borderRadius='12px'
                mx='16px'
                my='8px'
              >
                {chatData.map((chat: any, index) => {
                  console.log('🎨 Rendering ChatBubble', { index, chatId: chat._id, message: chat.messages?.[0] });
                  return (
                    <ChatBubble
                      chat={chat}
                      previousDate={(chatData as any)[index - 1]?.createdAt}
                      key={chat._id || chat.id || index}
                      counsellor={
                        session?.supervisor
                          ? session.supervisor
                          : session?.counsellor
                      }
                    />
                  );
                })}
                <Box ref={messagesEndRef} />
              </Box>
              <Flex
                bg='white'
                minH='86px'
                pr='38px'
                pl='18px'
                pt='12px'
                alignItems='flex-start'
                borderRadius='12px'
                mx='16px'
                mb='8px'
                boxShadow='0 2px 8px rgba(0, 0, 0, 0.1)'
                border='1px solid #e2e8f0'
              >
                {sessionFilter === 'my sessions' &&
                  statusFilter === 'active' && (
                    <>
                      <Flex
                        height='50px'
                        alignItems='center'
                        mr='28px'
                        cursor='pointer'
                        onClick={() => toggleEmoji(!showEmoji)}
                      >
                        <Smiley />
                      </Flex>
                      <Textarea
                        minH='50px'
                        maxH='150px'
                        flexGrow={1}
                        placeholder='Write a message...'
                        mr='30px'
                        border='none'
                        borderRadius='12px'
                        bg='gray.50'
                        _focus={{
                          outline: 'none',
                          boxShadow: 'none',
                          bg: 'white',
                          border: '2px solid #3182ce'
                        }}
                        _placeholder={{
                          color: 'gray.500'
                        }}
                        resize='none'
                        pt='15px'
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyPress={(e) => handleKeyPress(e.key)}
                        value={message}
                      ></Textarea>
                      <Flex height='50px' alignItems='center'>
                        <Input
                          type='file'
                          id='attach-file'
                          accept='image/jpeg, image/png,video/mp4,video/3gp,image/webp,text/plain, application/pdf, application/vnd.ms-powerpoint, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.8wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,audio/aac, audio/mp4, audio/mpeg, audio/amr, audio/ogg,video/3gp'
                          ref={attachRef}
                          display='none'
                          onChange={addAttachment}
                        />
                        <span
                          onClick={() => {
                            if (attachRef.current !== null)
                              attachRef.current.click();
                          }}
                        >
                          <Clip />
                        </span>
                        <Flex
                          boxSize='40px'
                          borderRadius='20px'
                          bg='deep_blue'
                          ml='30px'
                          justifyContent='center'
                          alignItems='center'
                          cursor='pointer'
                          onClick={() => {
                            if (message.trim().length)
                              addMessage(message).catch((err) =>
                                console.error(err)
                              );
                          }}
                        >
                          <Icon name='Send' filled color='#ffffff' />
                        </Flex>
                      </Flex>
                    </>
                  )}
              </Flex>
              {showEmoji ? (
                <EmojiPicker
                  width='100%'
                  height={300}
                  searchDisabled={true}
                  previewConfig={{
                    showPreview: false
                  }}
                  onEmojiClick={({ emoji }) => setMessage(message + emoji)}
                />
              ) : null}
            </>
          )}
        </Flex>
      </Grid>
      <ModalView
        isOpen={isCaseModalOpen}
        onClose={onCaseModalClose}
        bg='gray_50'
        maxW='800px'
        noCloseBtn
      >
        <Box bg='gray_50' px='55px' py='75px' borderRadius='8px'>
          <Headline size='19px' color='gray' mb='28px' textAlign='center'>
            Close Case - Case Feedback Form
          </Headline>
          
          <VStack spacing={4} align='stretch'>
            {isCaseSafetyFlagged(caseItem) &&
              !caseItem?.safetyReview?.completedAt && (
                <>
                  <Headline size='16px' color='#FF7171'>
                    Safety Review (Required)
                  </Headline>
                  <FormControl isRequired>
                    <FormLabel>Threat summary</FormLabel>
                    <Textarea
                      bg={colors.white}
                      borderRadius='15px'
                      border='none'
                      value={threatSummary}
                      onChange={(e) => setThreatSummary(e.target.value)}
                      resize='none'
                      placeholder='Summarize the safety threat...'
                    />
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel>Actions taken</FormLabel>
                    <Textarea
                      bg={colors.white}
                      borderRadius='15px'
                      border='none'
                      value={actionsTaken}
                      onChange={(e) => setActionsTaken(e.target.value)}
                      resize='none'
                      placeholder='Describe actions taken...'
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Client safety plan</FormLabel>
                    <Textarea
                      bg={colors.white}
                      borderRadius='15px'
                      border='none'
                      value={clientSafetyPlan}
                      onChange={(e) => setClientSafetyPlan(e.target.value)}
                      resize='none'
                      placeholder='Optional client safety plan...'
                    />
                  </FormControl>
                  <Checkbox
                    isChecked={supervisorNotified}
                    onChange={(e) => setSupervisorNotified(e.target.checked)}
                  >
                    Supervisor notified
                  </Checkbox>
                  <Checkbox
                    isChecked={emergencyServicesContacted}
                    onChange={(e) =>
                      setEmergencyServicesContacted(e.target.checked)
                    }
                  >
                    Emergency services contacted
                  </Checkbox>
                </>
              )}
            {/* Reason */}
            <FormControl isRequired>
              <FormLabel>Reason for Closing Case</FormLabel>
              <Textarea
                bg={colors.white}
                borderRadius='15px'
                border='none'
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                resize='none'
                placeholder='Type reason here...'
              />
            </FormControl>

            {/* Backstory */}
            <FormControl isRequired>
              <FormLabel>Backstory</FormLabel>
              <Textarea
                bg={colors.white}
                borderRadius='15px'
                border='none'
                value={backstory}
                onChange={(e) => setBackstory(e.target.value)}
                resize='none'
                placeholder='Describe the case backstory...'
              />
            </FormControl>

            {/* Help Provided */}
            <FormControl isRequired>
              <FormLabel>Help Provided</FormLabel>
              <Textarea
                bg={colors.white}
                borderRadius='15px'
                border='none'
                value={helpProvided}
                onChange={(e) => setHelpProvided(e.target.value)}
                resize='none'
                placeholder='Describe the help provided...'
              />
            </FormControl>

            {/* Overall Feedback */}
            <FormControl isRequired>
              <FormLabel>Overall Feedback</FormLabel>
              <Textarea
                bg={colors.white}
                borderRadius='15px'
                border='none'
                value={overallFeedback}
                onChange={(e) => setOverallFeedback(e.target.value)}
                resize='none'
                placeholder='Provide overall feedback...'
              />
            </FormControl>

            {/* Row 1: Session Number and Average Time */}
            <HStack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Session Number</FormLabel>
                <NumberInput
                  value={sessionNumber}
                  onChange={(valueString, valueNumber) => setSessionNumber(valueNumber)}
                  min={1}
                  max={100}
                >
                  <NumberInputField bg={colors.white} borderRadius='15px' border='none' />
                  <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                  </NumberInputStepper>
                </NumberInput>
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Average Time on Session</FormLabel>
                <Input
                  bg={colors.white}
                  borderRadius='15px'
                  border='none'
                  value={averageTimeOnSession}
                  onChange={(e) => setAverageTimeOnSession(e.target.value)}
                  placeholder='e.g., 45 minutes'
                />
              </FormControl>
            </HStack>

            {/* Row 2: Counselling Team and Checkboxes */}
            <HStack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Counselling Team</FormLabel>
                <Select
                  bg={colors.white}
                  borderRadius='15px'
                  border='none'
                  value={counsellingTeam}
                  onChange={(e) => setCounsellingTeam(e.target.value)}
                  placeholder='Select counselling team'
                >
                  <option value='UNASIGNED'>UNASIGNED</option>
                  <option value='ALPHA'>ALPHA</option>
                  <option value='BETA'>BETA</option>
                  <option value='GAMMA'>GAMMA</option>
                  <option value='DELTA'>DELTA</option>
                  <option value='EPSILON'>EPSILON</option>
                  <option value='ZETA'>ZETA</option>
                  <option value='THETA'>THETA</option>
                  <option value='KAPPA'>KAPPA</option>
                  <option value='OMEGA'>OMEGA</option>
                </Select>
              </FormControl>

              <VStack spacing={2} align='start'>
                <FormControl>
                  <Checkbox
                    isChecked={hasClientFilledForm}
                    onChange={(e) => setHasClientFilledForm(e.target.checked)}
                  >
                    Client Filled Form
                  </Checkbox>
                </FormControl>
                <FormControl>
                  <Checkbox
                    isChecked={hasResidueEmotion}
                    onChange={(e) => setHasResidueEmotion(e.target.checked)}
                  >
                    Has Residue Emotion
                  </Checkbox>
                </FormControl>
              </VStack>
            </HStack>
          </VStack>

          <HStack spacing={4} mt='34px'>
            <PrimaryButton
              label='Close Case'
              background={colors.deep_blue}
              onClick={closeCase}
              isLoading={closeCaseLoading}
              flex={1}
            />
            <TextButton label='Cancel' onClick={onCaseModalClose} />
          </HStack>
        </Box>
      </ModalView>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={'2xl'}
        scrollBehavior={'inside'}
      >
        <ModalOverlay />

        <ModalContent>
          {file !== null && canSendMedia(file) && (
            <ModalHeader>{`${capitalize(
              getMediaType(file.type)
            )} size must not be larger than ${
              fileSizes[getMediaType(file.type)]
            }`}</ModalHeader>
          )}
          <ModalCloseButton color={colors.deep_blue} />
          <ModalBody paddingX={12} paddingTop={12}>
            {file &&
              media &&
              (getMediaType(file?.type) === 'image' ||
                getMediaType(file?.type) === 'sticker') && (
                <Image src={media} />
              )}
            {file && media && getMediaType(file?.type) === 'video' && (
              <video src={media} controls />
            )}
            {file && media && getMediaType(file?.type) === 'document' && (
              <Box width={'100%'} bg={colors.deep_blue} borderRadius={10}>
                <Text
                  padding={10}
                  color={colors.white}
                  w={'max-content'}
                  m={'auto'}
                >
                  {file?.name}
                </Text>
              </Box>
            )}
          </ModalBody>
          <ModalFooter display='flex' alignItems={'center'} paddingX={12}>
            {file &&
              ['image', 'document', 'sticker', 'video'].includes(
                getMediaType(file.type)
              ) && (
                <>
                  <Text flex={1} color={colors.deep_blue}>
                    Add Caption
                  </Text>
                  <Input
                    borderColor={colors.deep_blue}
                    flex={3}
                    value={caption}
                    onChange={(e) => setCaption(e.target.value)}
                  />
                </>
              )}
            <Button
              rightIcon={<ArrowForwardIcon />}
              colorScheme='blue'
              variant='solid'
              // flex={1}
              ml={2}
              justifySelf={'flex-end'}
              isDisabled={file !== null && canSendMedia(file)}
              onClick={sendAttachment}
            >
              Send
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </DashboardLayout>
  );
};
export default Sessions;
